export default __webpack_public_path__ + "static/media/circle_4.1615b8ab.svg";